/* ============
 * EXCISE DUTIES Module Mutations
 * ============
 */

import {
  FETCH_EXCISE_GROUPS,
  FETCH_EXCISE_PACKAGING_GROUPS,
  ADD_NULL_TO_EXCISE_GROUPS_LIST,
  FETCH_EXCISE_BASIC,
} from './../../mutation-types';

export default {
  [FETCH_EXCISE_GROUPS](state, { exciseGroups }) {
    state.all = exciseGroups;
    state.all.splice(0, 0, { id: '', name: '', title: '', description: '' });
  },

  [FETCH_EXCISE_PACKAGING_GROUPS](state, { excisePackagingGroups }) {
    state.packaging = excisePackagingGroups;
    state.packaging.splice(0, 0, { id: '', name: '', title: '', description: '' });
  },

  [FETCH_EXCISE_BASIC](state, { exciseBasicGroups }) {
    state.basic = exciseBasicGroups;
    state.basic.splice(0, 0, { id: '', name: '', title: '', description: '' });
  },

  [ADD_NULL_TO_EXCISE_GROUPS_LIST](state) {
    state.all.splice(0, 0, { id: '', name: '', title: '', description: '' });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/exciseGroup/mutations.js